<template>
    <v-container fluid>
        <v-snackbar v-model="snackbar.mostrar" :color="snackbar.tipo" :timeout="6000">
            {{ snackbar.mensaje }}
            <v-btn text @click="snackbar.mostrar = false">
                {{ $t('cerrar') | capitalize }}
            </v-btn>
        </v-snackbar>

        <v-dialog v-model="dialogoBorrarUno" persistent max-width="290">
            <v-card>
                <v-card-title class="headline error white--text">
                    {{ $t('titulo_borrar_muestreo') }}
                </v-card-title>
                <v-card-text class="pt-2">
                    {{ $t('msg_borrar_muestreo') }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogoBorrarUno = false">
                        {{ $t("cerrar") | capitalize }}
                    </v-btn>
                    <v-btn color="error" text @click="borrarMuestreo(borrarUno)">
                        {{ $t("borrar") | capitalize }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoBorrarTodos" persistent max-width="290">
            <v-card>
                <v-card-title class="headline error white--text">
                    {{ $t('titulo_borrar_muestreos') }}
                </v-card-title>
                <v-card-text class="pt-2">
                    {{ $t('msg_borrar_muestreos') }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogoBorrarTodos = false">
                        {{ $t("cerrar") | capitalize }}
                    </v-btn>
                    <v-btn color="error" text @click="borrarTodosMuestreo(borrarUno)">
                        {{ $t("borrar") | capitalize }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-alert v-if="!cargando && paginas == 0" type="info" class="ma-12">
            <span class="body-1">{{ $t('sin_muestreos') }}&nbsp;</span>
            <btn-subir-muestreos class="d-inline-block" :reducido="false"
                                 @change="obtenerMuestreos()"></btn-subir-muestreos>
        </v-alert>

        <v-alert v-if="cargando && paginas == 0" type="info" class="ma-12">
            <span class="body-1">{{ $t('cargando_muestreos') }}&nbsp;</span>
            <v-progress-circular color="primary" :indeterminate="true"></v-progress-circular>
        </v-alert>
        <v-row no-gutters>
            <v-col cols="12">
                <div v-if="paginas > 0">
                    <v-toolbar color="primary white--text" elevation="0">
                        <v-toolbar-title class="font-weight-bold">{{ $tc('listado_muestreos', 2) | capitalize }}
                        </v-toolbar-title>

                        <div class="flex-grow-1"></div>

                        <template>
                            <v-btn icon color="white" :loading="cargando" @click="obtenerMuestreos()">
                                <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                            <btn-subir-muestreos :reducido="true" @change="obtenerMuestreos()"></btn-subir-muestreos>
                            <v-btn icon color="red" @click="dialogoBorrarTodos = true">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                    </v-toolbar>

                    <v-list>
                        <div v-if="cargando">
                            <v-skeleton-loader v-for="i in porPagina" :key="i"
                                               ref="skeleton"
                                               type="list-item-three-line"
                                               class="mx-auto"
                            ></v-skeleton-loader>
                        </div>
                        <div v-if="!cargando">
                            <v-list-item v-for="(muestreo,index) in listado" :key="index" three-line-line
                                         class="muestreo-item">
                                <v-list-item-content>
                                    <v-row align="center" justify="center" no-gutters>
                                        <v-col cols="11">
                                            <v-list-item-title class="primary--text font-weight-bold">
                                                {{ muestreo.componentes }} {{ muestreo.tipoSolCons }}
                                            </v-list-item-title>

                                            <v-list-item-subtitle>
                                                {{ muestreo.tipoSolCons.nombre }}
                                            </v-list-item-subtitle>

                                            <v-list-item-subtitle class="body-1 font-italic">
                                                <span class="font-weight-bold">Distancia:</span>
                                                {{ muestreo.distanciaSuministro.nombre }}
                                                <span v-if="muestreo.distanciaSuministroKm != null">
                                            ({{ muestreo.distanciaSuministroKm }} Km)
                                        </span>&nbsp;
                                                <span class="font-weight-bold">Precio:</span>
                                                <span v-if="muestreo.costeUnitarioAcabado != null">
                                            {{ muestreo.costeUnitarioAcabado }} €&nbsp;
                                        </span>
                                                <span v-if="muestreo.costeUnitarioAcabado == null">
                                            Por defecto&nbsp;
                                        </span>
                                                <span v-if="muestreo.tipoSolCons == 'HORIZONTAL'">
                                        <span class="font-weight-bold">Intensidad tránsito:</span>
                                            {{ muestreo.intensidadTransito.nombre }}&nbsp;
                                        <span class="font-weight-bold">Frecuencia mantenimiento:</span>
                                            {{ muestreo.frecuenciaMantenimiento.nombre }}
                                        </span>
                                        <span v-if="muestreo.tipoSolCons == 'EXTERIORES'">
                                          <span class="font-weight-bold">Riesgo helada:</span>
                                            {{ muestreo.riesgoH.nombre }}&nbsp;
                                        </span>
                                        <span v-if="muestreo.tipoSolCons == 'EXTERIORES_REHABILITACION'">
                                          <span class="font-weight-bold">Riesgo helada:</span>
                                            {{ muestreo.riesgoH.nombre }}&nbsp;
                                        </span>
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="1">
                                            <v-tooltip v-if="muestreo.procesado && !tieneErrores(muestreo)" bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon color="success" v-on="on">
                                                        mdi-check
                                                    </v-icon>
                                                </template>
                                                <span>{{ $t('muestreo_sin_error') }}</span>
                                            </v-tooltip>

                                            <btn-ver-errores v-if="muestreo.procesado && tieneErrores(muestreo)"
                                                             :errores="muestreo.errores">
                                            </btn-ver-errores>

                                            <v-tooltip v-if="!muestreo.procesado" bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon color="warning" v-on="on">
                                                        mdi-information
                                                    </v-icon>
                                                </template>
                                                <span>{{ $t('muestreo_procesando') }}</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-btn icon v-if="muestreo.proyecto"
                                                   @click="goToBlank(`proyecto-detalles/${muestreo.proyecto.id}`)">
                                                <v-icon color="grey lighten-1">mdi-open-in-new</v-icon>
                                            </v-btn>
                                            <v-btn icon v-if="muestreo.proyecto" @click="abrirLog(muestreo)">
                                                <v-icon color="grey lighten-1">mdi-text</v-icon>
                                            </v-btn>
                                            <v-btn icon color="red" @click="confirmarBorrarUno(muestreo)">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-list-item-action>
                            </v-list-item>
                        </div>
                    </v-list>

                    <div class="text-center">
                        <v-pagination
                            circle
                            v-model="pagina"
                            :length="paginas"
                            :disabled="cargando"
                        ></v-pagination>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";
    import BtnSubirMuestreos from "./Componentes/BtnSubirMuestreos";
    import BtnVerErrores from "./Componentes/BtnVerErrores";
    import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";

    export default {
        name: 'AdminMuestreosPagina',
        components: {
            BtnSubirMuestreos,
            BtnVerErrores
        },
        data: () => ({
            listado: [],
            cargando: false,
            pagina: 1,
            porPagina: 4,
            paginas: 0,
            dialogoBorrarUno: false,
            borrarUno: null,
            dialogoBorrarTodos: false,
            snackbar: {
                tipo: "error",
                mostrar: false,
                mensaje: ""
            }
        }),
        mounted: function () {
            this.obtenerMuestreos();
        },
        watch: {
            pagina: function () {
                this.obtenerMuestreos();
            }
        },
        methods: {
            obtenerMuestreos() {
                this.cargando = true;
                let params = {
                    pagina: this.pagina - 1,
                    porPagina: this.porPagina
                };
                HttpHelper.get(`admin/muestreos/listado`, params)
                    .then((muestreos) => {
                        if (muestreos.content.length < 1) {
                            this.pagina = 1;
                            this.listado = [];
                            this.paginas = 0;
                            return;
                        }

                        this.listado = muestreos.content;
                        this.paginas = muestreos.totalPages;
                    })
                    .catch(() => {
                        this.listado = [];
                        this.pagina = 1;
                        this.paginas = 0;
                    })
                    .finally(() => {
                        this.cargando = false;
                    });
            },
            confirmarBorrarUno(muestreo) {
                this.borrarUno = muestreo;
                this.dialogoBorrarUno = true;
            },
            borrarMuestreo(muestreo) {
                this.dialogoBorrarUno = false;
                this.borrarUno = muestreo;
                this.cargando = true;
                HttpHelper.get(`admin/muestreos/borrar/${muestreo.id}`)
                    .then(() => {
                        this.listado = [];
                        this.pagina = 1;
                        this.obtenerMuestreos();
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.cargando = false;
                    });
            },
            borrarTodosMuestreo() {
                this.dialogoBorrarTodos = false;
                this.cargando = true;
                HttpHelper.get(`admin/muestreos/borrar-todos`)
                    .then(() => {
                        this.obtenerMuestreos();
                        this.dialogoBorrarTodos = false;
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.cargando = false;
                    });
            },
            abrirLog(muestreo) {
                HttpHelper.get(`admin/muestreos/log/${muestreo.id}`)
                    .then((ficheroLog) => {
                        const linkSource = `data:${ficheroLog.mime};base64,${ficheroLog.datos}`;
                        const downloadLink = document.createElement("a");
                        const fileName = ficheroLog.nombre;
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    })
                    .catch(() => {
                        this.snackbar.mensaje = this.$t('error_log_muestreo') + " " + muestreo.id;
                        this.snackbar.tipo = "error";
                        this.snackbar.mostrar = true;
                    })
                    .finally(() => {
                    });
            },
            tieneErrores(muestreo) {
                return Object.keys(muestreo.errores).length > 0 && muestreo.errores.constructor === Object;
            },
            goTo(path) {
                VueRouteHelper.goTo(path, this.$router);
            },
            goToBlank(path) {
                VueRouteHelper.inNewTab(path, this.$router);
            },
        }
    };
</script>

<style lang="scss" scoped>
    .v-alert.info {
        background-color: #f7d9cd !important;
        color: #40108e !important;

        .v-icon {
            color: #40108e;
            font-size: 30px;
            margin-top: 5px;
        }
    }

    .muestreo-item {
        min-height: 88px;
        max-height: 88px;
    }
</style>

<!-- @formatter:off -->
<i18n>
    {
    "es": {
    "cargando_muestreos": "Cargando muestreos",
    "listado_muestreos": "Muestreos",
    "sin_muestreos": "No se han obtenido muestreos, puedes añadir muestreos pulsando este botón ",
    "muestreo_procesando": "El muestreo todavía no se ha procesado, espera unos minutos y vuelve a comprobarlo",
    "muestreo_sin_error": "El muestreo se ha procesado y no tiene errores",
    "titulo_borrar_muestreo": "Borrar muestreo",
    "msg_borrar_muestreo": "¿Seguro que deseas borrar el muestreo?",
    "titulo_borrar_muestreos": "Borrar muestreos",
    "msg_borrar_muestreos": "¿Seguro que deseas borrar todos los muestreos?",
    "error_log_muestreo": "No se puede descargar el log del muestreo"
    }
    }
</i18n>
<!-- @formatter:on -->